<template>
  <div class="content">

    <div class="card card-outline card-primary">
      <div class="card-header">
        <div class="row">
          <div class="col">
            <h2>Reports</h2>
          </div>
        </div>
      </div>
    </div>

    <div v-if="loadError" class="card card-outline card-danger">
      <div class="card-body">
        <p class="mb-1">{{ loadError }}</p>
        <p class="text-muted mb-0">
          If this persists, the report permissions may not have been seeded on this
          environment.
        </p>
      </div>
    </div>

    <div v-else-if="!catalogLoaded" class="card card-outline">
      <div class="card-body text-muted">Loading reports&hellip;</div>
    </div>

    <div v-else-if="catalog.length === 0" class="card card-outline">
      <div class="card-body text-muted">
        No reports are available to your account.
      </div>
    </div>

    <!--
      One card per group, in FrameTracker's own menu order with its own captions.
      The groups come from the server already filtered to what this user may run —
      a report they have no permission for is never named here.
    -->
    <div class="row" v-else>
      <div class="col-md-6" v-for="group in catalog" :key="group.key">
        <div class="card card-outline card-primary">
          <div class="card-header">
            <h3 class="card-title">{{ group.label }}</h3>
          </div>
          <div class="card-body p-0">
            <ul class="nav nav-pills flex-column">
              <li class="nav-item" v-for="report in group.reports" :key="report.slug">

                <router-link
                    v-if="report.implemented"
                    class="nav-link"
                    :to="{ name: 'ReportRunner', params: { slug: report.slug } }">
                  {{ report.label }}
                </router-link>

                <!--
                  Catalogued but not yet migrated. Shown rather than hidden so the
                  remaining work is visible in the product, and so the menu matches
                  what an operator expects to find.
                -->
                <span v-else class="nav-link text-muted" :title="report.legacy || ''">
                  {{ report.label }}
                  <span class="badge badge-light float-right">Not yet migrated</span>
                </span>

              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {mapGetters} from "vuex";

/**
 * The report index.
 *
 * Holds no list of reports: the grouping, captions and order all come from
 * GET /admin/report/catalog, which mirrors FrameTracker's Reports menu
 * (frmMainmenu.dfm:462-700). Adding a report to the API adds it here.
 */
export default {
  name: "Reports",
  data() {
    return {
      loadError: null,
    }
  },
  computed: {
    ...mapGetters({
      'catalog': 'Reports/getCatalog',
      'catalogLoaded': 'Reports/catalogLoaded',
    }),
  },
  mounted() {
    this.$store.dispatch('Reports/fetchCatalog')
        .catch(() => {
          this.loadError = this.$store.getters['Reports/getError']
              || 'Could not load the report list.'
        })
  },
}
</script>

<style scoped>
.nav-pills .nav-link {
  border-radius: 0;
}
</style>
